import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { BdMoveFormComponent } from '../move-dialog/move-form/move-form.component';
import { BdUiDialogPrimaryActionDirective } from '@bindoc-projects/ui-lib/dialog/ui';

/**
 * Lightweight "choose a folder" dialog. Wraps the existing folder tree
 * ({@link BdMoveFormComponent}) and closes with the selected folder id, or
 * `null` when cancelled. Unlike {@link BdMoveDialogComponent} it does not run
 * the move itself — the caller decides what to do with the chosen folder
 * (e.g. create a resource and then move it there).
 */
@Component({
  selector: 'bd-folder-location-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <bd-move-form (folderChange)="selectedFolderId.set($event)"></bd-move-form>
    <div class="flex flex-row gap-4 justify-end w-full pt-4">
      <button
        pButton
        [outlined]="true"
        severity="secondary"
        (click)="ref.close(null)"
        data-test="folder-location-dialog-cancel"
      >
        <span>Abbrechen</span>
      </button>
      <button
        pButton
        bdDialogPrimaryAction
        [raised]="true"
        [disabled]="!selectedFolderId()"
        (click)="ref.close(selectedFolderId())"
        data-test="folder-location-dialog-confirm"
      >
        <span>Speichern</span>
      </button>
    </div>
  `,
  imports: [
    BdUiDialogPrimaryActionDirective,
    ButtonDirective,
    BdMoveFormComponent,
  ],
})
export class BdFolderLocationDialogComponent {
  public readonly ref = inject(DynamicDialogRef);
  public readonly selectedFolderId = signal<string | null>(null);
}
